interface SelectOptionProps {
    handlerChangeLenguage: (lang: string) => void;
    language: string;
    languageName: string;
    flagRoute: string;
}

export const SelectOption = ({
    handlerChangeLenguage,
    language,
    languageName,
    flagRoute,
}: SelectOptionProps) => {
    return (
        <li
            style={{
                cursor: 'pointer',
            }}
            className='nav-item px-2 p-1 d-flex justify-content-start aling-items-center '
            onClick={(e) => handlerChangeLenguage(language)}
        >
            <span
                className=''
                style={{
                    marginRight: 7,
                    width: 20,
                    height: 20,
                    border: 'none',
                    borderRadius: '50%',
                }}
            >
                <img src={flagRoute} className='h-100 w-100  rounded-pill' alt='' />
            </span>
            <span className='fs-9'>{languageName}</span>
        </li>
    );
};
